// SharedContext.js

import { createContext, useState, useRef, useEffect } from 'react'
import { useRouter } from 'next/router'
import { useLocalStorage } from '../hooks/useLocalStorage'
import useWindowSize from '../hooks/useWindowSize'
import useAppVersion from '../hooks/useAppVersion'
import { REQUIRED_VERSION_FOR_PAY_LATER } from '../constants/advertiser'
import { LOGIN_DEFAULT_DETAILS } from '../constants/all'
import Cookies from 'universal-cookie'
import { useSessionStorage } from '@/hooks/useSessionStorage'

export const SharedContext = createContext()

export const SharedContextProvider = ({ children, skeletonloader, setSkeletonloader }) => {
  // ----------- U STATES (useState) -----------
  const [isMenuClicked, setMenuClicked] = useState(false)
  const [showToast, setShowToast] = useState({ isVisible: false })
  const [isScrollBarPresent, setScrollBar] = useState(true)
  const [language, setLanguage] = useState('en')
  const [isOnline, setOnline] = useState(true)

  // ----------- L STATES (useLocalStorage) -----------
  const [loginDetails, setLoginDetails] = useLocalStorage('loginDetails', LOGIN_DEFAULT_DETAILS)
  const [utmParams, setUtmParams] = useLocalStorage('utm_params', {})
  const [location, setLocation] = useLocalStorage('location', null)
  const [historyStack, setHistoryStack] = useLocalStorage('historyStack', {
    isForword: false,
    data: [],
    isBack: false
  })

  // ----------- READ-ONLY HOOKS/REF -----------
  const router = useRouter()
  const windowSize = useWindowSize()
  const laterAndroidVersion = useAppVersion(REQUIRED_VERSION_FOR_PAY_LATER)
  const countryCode = useRef('91')
  const cookie = new Cookies()

  // S STATES (useSessionStorage)
  const [defaultLocationId, setDefaultLocationId] = useSessionStorage('defaultLocationId', '');

  useEffect(() => {
    cookie.set('location', location, { path: '/' })
  }, [location])

  useEffect(() => {
    cookie.set('language', language, { path: '/' })
  }, [language])

  useEffect(() => {
    setHistoryStack((prv) => {
      if (router?.pathname == '/404')
        return { ...prv }
      const prvRoute = prv?.data?.[prv?.data?.length - 2]
      if (prvRoute?.as == router?.asPath && !prv?.isForword) {
        prv?.data?.pop()
      } else {
        let lastRoute = prv?.data?.[prv?.data?.length - 1]
        if (lastRoute?.as != router?.asPath) {
          prv?.data?.push({
            pathname: router?.pathname,
            query: JSON?.stringify(router?.query),
            as: router?.asPath
          })
        }
      }
      prv.isForword = false
      prv.isBack = false
      return { ...prv }
    })
  }, [router])

  useEffect(() => {
    try {
      if (windowSize > 640) {
        if (isScrollBarPresent) {
          document.body.style.overflow = 'auto'
        } else document.body.style.overflow = 'hidden'
      }
    } catch {}
  }, [isScrollBarPresent])


  return (
    <SharedContext.Provider
      value={{
        // U states
        isMenuClicked,
        setMenuClicked,
        showToast,
        setShowToast,
        isScrollBarPresent,
        setScrollBar,
        language,
        setLanguage,
        isOnline,
        setOnline,

        // L states
        loginDetails,
        setLoginDetails,
        utmParams,
        setUtmParams,
        location,
        setLocation,
        historyStack,
        setHistoryStack,

        // Other hooks/refs
        windowSize,
        laterAndroidVersion,
        countryCode,
        cookie,
        skeletonloader,
        setSkeletonloader,

        //S states
        defaultLocationId,
        setDefaultLocationId
      }}
    >
      {children}
    </SharedContext.Provider>
  )
}
